import freeEmailDomains from "free-email-domains";
import * as yup from "yup";
import * as psl from "psl";


export const isValidBusinessEmail = (value: string, isDomain: boolean = false) => {
  if (value && value.includes("@") || isDomain) {
    const domain = value?.toLocaleLowerCase().split('@').pop() ?? "";
    const parsed = psl.parse(domain) as psl.ParsedDomain;
    if (parsed?.domain && freeEmailDomains.includes(parsed?.domain)) {
      return false
    }
  }
  return true
}

export default yup;